import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientQaspPage from "@/pages/client/ClientQaspPage";

export const Route = createFileRoute("/client/contracts/$contractId/qasp")({
  head: () => pageHead("Client · Contracts · Qasp", "AKIVA client · contracts · qasp portal.", "/client/contracts/$contractId/qasp", true),
  component: ClientQaspPage,
});
